import { Pipe, PipeTransform } from '@angular/core';

export type OmniModelViewType =
  | 'channel'
  | 'tactic'
  | 'campaign'
  | 'subCampaign'
  | 'tacticDimension'
  | 'campaignDimension'
  | 'channelDimension'
  | 'subCampaignDimension'
  | undefined;

export interface OmniValueDisplay {
  icon: string;
  iconClass: string;
  tooltipContent: string;
  showTooltip: boolean;
}

@Pipe({
  name: 'formatOmniValue',
  standalone: true
})
export class FormatOmniValuePipe implements PipeTransform {
  transform(
    value: string | number,
    dashboardFieldId: string,
    viewType: OmniModelViewType = undefined, //channel / tactic / campaign / subCampaign
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prevPeriodAttributes?: Record<string, any>
  ): OmniValueDisplay | undefined {
    let updatedValue = value;
    if (
      dashboardFieldId !== 'percInc' &&
      dashboardFieldId !== 'adjustment_factor_mim_xcd'
    ) {
      return undefined;
    }

    if (
      prevPeriodAttributes &&
      dashboardFieldId === 'percInc' &&
      value === undefined
    ) {
      updatedValue = prevPeriodAttributes?.[dashboardFieldId]?.prevValue;
    }

    switch (updatedValue) {
      case '-':
      case 0:
      case null:
      case 'NaN':
      case 'Infinity':
      case '-Infinity':
      case '0':
        return {
          icon: 'exclamation',
          iconClass: 'material-symbols-outlined text-orange-300 icon-small',
          tooltipContent:
            'The adjustment factor is absent since <br> either it was not applied or there are <br> no platform metrics available.',
          showTooltip: true
        };
      case -1:
      case -100:
      case '-1':
      case '-100':
      case '-100.0%':
        return {
          icon: 'app_badging',
          iconClass: 'material-symbols-outlined text-gray-600 icon-small',
          tooltipContent: this.getTooltipContentForSpendModel(viewType),
          showTooltip: true
        };
      default:
        return undefined;
    }
  }

  getTooltipContentForSpendModel(
    viewType:
      | 'channel'
      | 'tactic'
      | 'campaign'
      | 'subCampaign'
      | 'tacticDimension'
      | 'campaignDimension'
      | 'channelDimension'
      | 'subCampaignDimension'
      | undefined
  ): string {
    const channelTooltip =
      'Spend-based tactic in this channel do <br> not have adjustment factors.';
    const tacticTooltip =
      'Spend-based tactics do not have <br> adjustment factors.';
    const campaignTooltip =
      'Campaigns within spend-based tactics <br> do not have adjustment factors.';
    const subCampaignTooltip =
      'Sub-campaigns within spend-based <br> tactics do not have adjustment factors.';

    const tooltipMsgMapping = {
      channel: channelTooltip,
      channelDimension: channelTooltip,
      tactic: tacticTooltip,
      tacticDimension: tacticTooltip,
      campaign: campaignTooltip,
      campaignDimension: campaignTooltip,
      subCampaign: subCampaignTooltip,
      subCampaignDimension: subCampaignTooltip
    };

    return viewType && tooltipMsgMapping[viewType]
      ? tooltipMsgMapping[viewType]
      : tacticTooltip;
  }
}
